import { Link } from "react-router-dom";
import { LomooloLogo } from "@/components/ui/LomooloLogo";

const footerCols = [
  { title: "PRODUKT", links: [
    { label: "Funktioner", href: "/funktioner" },
    { label: "Priser", href: "/priser" },
    { label: "Så funkar det", href: "/sa-funkar-det" },
  ]},
  { title: "FÖRETAG", links: [
    { label: "Om oss", href: "/om-oss" },
    { label: "Blogg", href: "/blogg" },
    { label: "Kontakt", href: "/kontakt" },
  ]},
  { title: "JURIDISKT", links: [
    { label: "Villkor", href: "/villkor" },
    { label: "Integritetspolicy", href: "/integritetspolicy" },
  ]},
];

const V3Footer = () => (
  <footer className="bg-v3-footer" role="contentinfo">
    <div className="max-w-7xl mx-auto px-5 py-16">
      <div className="grid md:grid-cols-4 gap-10">
        <div>
          <LomooloLogo size="sm" variant="light" />
          <p className="mt-4 text-[13px] text-white/50 leading-relaxed">
            Du slipper stressen.<br />Du behåller rösten.
          </p>
          {/* Hidden but crawlable logo image for Google Images / Knowledge Panel */}
          <img
            src="/logo.webp"
            alt="Lomoolo Social – AI-driven innehållsplanering för småföretag"
            width="240"
            height="240"
            className="sr-only"
            loading="lazy"
            decoding="async"
          />
        </div>
        {footerCols.map(col => (
          <div key={col.title}>
            <h3 className="text-xs font-bold uppercase tracking-[1px] text-white mb-4">{col.title}</h3>
            <ul className="space-y-2.5">
              {col.links.map(l => (
                <li key={l.href}>
                  <Link to={l.href} className="text-[13px] text-white/50 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 text-center text-xs text-white/30">
        © 2026 LOMOOLO. Byggt i Sverige med ☕ och AI.
      </div>
    </div>
  </footer>
);

export default V3Footer;
